import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterChula extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday1'>
      <div><Link to='/'>Home</Link></div>
      <h3>CHULALONGKORN UNIVERSITY AIKIDO CLUB'S MEMBERS</h3>
      <br />
      <br />

      <div><Link to='/conduct-naruporns'>1. AAT  2339  MR.NARUPORN  SAOWANIT(Dojocho)(A)</Link></div>
      <br />
      <div><Link to='/conduct-wichaic'>2. AAT  5642  MR.WICHAI CHEEVAPITAKPHOL(A)</Link></div>
      <br />
      <div><Link to='/conduct-surather'>3. AAT  4132  MR.SURATHEE  RUNGTHINPHUTTHICHAI(A)</Link></div>
      <br />
      <div><Link to='/conduct-niwats'>4. AAT  6670  MR.NIWAT SEESANGNGAM(A)</Link></div>
      <br />
      <div><Link to='/conduct-thanachotec'>5. AAT  6681  MR.THANACHOTE CHEEVAPITAKPHOL(A)</Link></div>
      <br />
      <div><Link to='/conduct-matsakaj'>6. AAT  8002  MR.MATSAKA JANSAWANG(A)</Link></div>
      <br />
      <div><Link to='/conduct-nutchan'>7. AAT  7955  MS.NUTCHA  NAKAEW(A)</Link></div>
      <br />
      <div><Link to='/conduct-naphatsorny'>8. AAT  7954  MS.NAPHATSORN  YOTSIRIPORNCHAI(A)</Link></div>
      <br />
      <div><Link to='/conduct-pathikornk'>9. AAT  8068  MR.PATHIKORN KAJONRUNGSILP(A)</Link></div>
      <br />
        <br />
        <div>
          Thailand's Aikido Association Registration and Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterChula;
